<template>
  <BaseTableView v-if="items?.length > 0" :head="tableHead" list-view="mdAndUp">
    <template v-for="(item, key) in items">
      <SalaryTableItems :key="key" :item="item" :edit="edit" />
    </template>
  </BaseTableView>
  <Plug v-else />
</template>

<script>
import SalaryTableItems from './SalaryTableItems.vue'
import Plug from 'components/Plug.vue'

export default {
  name: 'SalaryTable',
  components: { Plug, SalaryTableItems },
  props: {
    items: [Array, Object],
    itemsHistory: [Array, Object],
    edit: Boolean,
  },
  computed: {
    translation() {
      return this.localStorage.translations.pages['setting-personal_area'].labels
    },
    tableHead() {
      return [
        { text: this.translation['salary_hourly'] },
        { text: this.translation['changed_by'] },
        { text: this.localStorage.translations.pages.finance['period-table'].date },
      ]
    },
  },
}
</script>

<style scoped lang="scss">
:deep() tbody {
  tr {
    td {
      width: 200px;
      &:first-of-type {
        width: 250px;
      }
    }
  }
}
</style>
